// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_botaoPopupSalvar__7tZ3E {
  width: 180px !important;
  background-color: #0f2047 !important;
  color: #ffffff !important;
  border-color: #ffffff !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
}

.styles_botaoPopupSalvar__7tZ3E:hover {
  transform: scale(0.95) !important;
}

.styles_botoesPopupGeral__l2Vuj {
  margin-top: 8px !important;
}

.styles_botaoPopupCancelar__0dgSx {
  width: 180px !important;
  background-color: #ffffff !important;
  color: #0f2047 !important;
  border-color: #0f2047 !important;
  border-width: 1px !important;
  border-style: solid !important;
  font-family: "Inter" !important;
  border-radius: 8px !important;
  transition: all 0.3s ease !important;
  font-weight: 600 !important;
}

.styles_botaoPopupCancelar__0dgSx:hover {
  transform: scale(0.95) !important;
}

.styles_formContent__U2OnE {
  flex-grow: 1;
}

.styles_formContainer__7IL5i {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
}

.styles_formDiv__1p17c {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
}
.styles_campoNumero__3ESdH {
  width: 120px !important;
}

.styles_filtrosTitulo__FNMKo {
  margin-bottom: 8px !important;
  font-weight: 600 !important;
}

.styles_filtrosVazio__3TZPu {
  padding: 8px 0 !important;
}

.styles_filtrosLoading__HW6nw {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 0;
}

.styles_tabelaFiltros__p6PpS {
  max-height: 220px;
}`, "",{"version":3,"sources":["webpack://./src/forms/ContaProtheusForm/styles.module.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;EACpC,yBAAyB;EACzB,gCAAgC;EAChC,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,6BAA6B;EAC7B,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,6BAA6B;EAC7B,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".botaoPopupSalvar {\n  width: 180px !important;\n  background-color: #0f2047 !important;\n  color: #ffffff !important;\n  border-color: #ffffff !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n}\n\n.botaoPopupSalvar:hover {\n  transform: scale(0.95) !important;\n}\n\n.botoesPopupGeral {\n  margin-top: 8px !important;\n}\n\n.botaoPopupCancelar {\n  width: 180px !important;\n  background-color: #ffffff !important;\n  color: #0f2047 !important;\n  border-color: #0f2047 !important;\n  border-width: 1px !important;\n  border-style: solid !important;\n  font-family: \"Inter\" !important;\n  border-radius: 8px !important;\n  transition: all 0.3s ease !important;\n  font-weight: 600 !important;\n}\n\n.botaoPopupCancelar:hover {\n  transform: scale(0.95) !important;\n}\n\n.formContent {\n  flex-grow: 1;\n}\n\n.formContainer {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n}\n\n.formDiv {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.campoNumero {\n  width: 120px !important;\n}\n\n.filtrosTitulo {\n  margin-bottom: 8px !important;\n  font-weight: 600 !important;\n}\n\n.filtrosVazio {\n  padding: 8px 0 !important;\n}\n\n.filtrosLoading {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 0;\n}\n\n.tabelaFiltros {\n  max-height: 220px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"botaoPopupSalvar": `styles_botaoPopupSalvar__7tZ3E`,
	"botoesPopupGeral": `styles_botoesPopupGeral__l2Vuj`,
	"botaoPopupCancelar": `styles_botaoPopupCancelar__0dgSx`,
	"formContent": `styles_formContent__U2OnE`,
	"formContainer": `styles_formContainer__7IL5i`,
	"formDiv": `styles_formDiv__1p17c`,
	"campoNumero": `styles_campoNumero__3ESdH`,
	"filtrosTitulo": `styles_filtrosTitulo__FNMKo`,
	"filtrosVazio": `styles_filtrosVazio__3TZPu`,
	"filtrosLoading": `styles_filtrosLoading__HW6nw`,
	"tabelaFiltros": `styles_tabelaFiltros__p6PpS`
};
export default ___CSS_LOADER_EXPORT___;
